import { Layout, BondLIst, BondInterestHistory } from '@/views/bond';

export default {
    path: '/bond',
    component: Layout,
    children: [
        { path: 'list', component: BondLIst },
        { path: 'interest-history', component: BondInterestHistory },
    ]
};
